import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useVerifyDomainMutation = createMutationHook(DnsApiClient.verifyDomain, {
  mutationKey: ['verifyDomain'],
})
